exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal{position:absolute;background:#fff;border-radius:5px;width:500px;height:320px;margin:auto;padding:30px;display:block;z-index:10}.modal-main{position:fixed;background:white;width:80%;height:auto;top:50%;left:50%;-webkit-transform:translate(-50%, -50%);-ms-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}.display-block{display:block}.display-none{display:none}.backdrop{position:fixed;top:0;bottom:0;left:0;right:0;background:rgba(0,0,0,0.3);padding:50;width:100%;height:100%;z-index:10}\n", ""]);

// exports
